function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons/Tabs/Warmte/White",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(3.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "W",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  points: "3.05689655 12.5241379 5.04310345 12.5086207 7.44827586 4.34655172 9.7137931 12.5086207 11.7155172 12.5086207 14.912069 1.72413793 13.0189655 1.72413793 10.7689655 10.4603448 8.51896552 1.72413793 6.53275862 1.72413793 4.11206897 10.5068966 1.87758621 1.72413793 7.90478794e-14 1.72413793"
}), /*#__PURE__*/React.createElement("g", {
  id: "Temperature/Warmte/Wit-Copy",
  transform: "translate(16.379310, -0.000000)",
  stroke: "#FFFFFF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.74137931,8.86091954 L4.74137931,2.15517241 C4.74137931,1.20295733 3.96945647,0.431034483 3.01724138,0.431034483 C2.06502629,0.431034483 1.29310345,1.20295733 1.29310345,2.15517241 L1.29310345,8.86091954 C0.411958485,9.65459317 0.184691314,10.9464177 0.742056132,11.9931644 C1.29942095,13.0399112 2.49811322,13.5724502 3.64848627,13.2843945 C4.79885933,12.9963387 5.60513979,11.9617505 5.60345093,10.7758621 C5.60188263,10.043914 5.28830643,9.34735673 4.74137931,8.86091954 L4.74137931,8.86091954 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 3.01724138,
  y1: 2.15517241,
  x2: 3.01724138,
  y2: 9.9137931,
  id: "Path"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 3.01724138,
  cy: 10.7758621,
  r: 1
}), /*#__PURE__*/React.createElement("line", {
  x1: 6.89655172,
  y1: 7.24137931,
  x2: 8.27586207,
  y2: 7.24137931,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 6.89655172,
  y1: 5.17241379,
  x2: 8.27586207,
  y2: 5.17241379,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 6.89655172,
  y1: 3.10344828,
  x2: 8.27586207,
  y2: 3.10344828,
  id: "Path"
}))));
function SvgHeatSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "20px",
    viewBox: "0 0 30 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Tabs/Warmte/White") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatSelected);
export default __webpack_public_path__ + "static/media/Heat_selected.9e86b887ea1739feca267ab6ea7188fd.svg";
export { ForwardRef as ReactComponent };